<template>
  <div class="studyCollection">
    <img class="study-floor-img" v-if="!isIndex" src="@/assets/studyBg.jpg" alt="" />
    <div class="studyCollection-inner">
      <div class="studyCollection-title" v-if="!isIndex">
        <img
          class="studyCollection-title-img"
          src="@/assets/studyLogo.png"
          alt=""
        />
      </div>
      <div class="studyCollection-info" ref="studyCollectionInfo">
        <div
          class="study-collection-show"
          v-for="item in studyList"
          :key="item.id"
          @click="goLink(item)"
        >
          <img class="study-collection-img" :src="item.showImg" alt="" />
          <div class="study-collection-work-info">
            <div class="study-collection-work-title">
              {{ lan ? item.studyEnTitle : item.studyCnTitle }}
            </div>
            <div class="study-collection-work-dec">
              <div v-html="lan ? item.contentEn : item.contentCn"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "studyCollection",
  data() {
    return {
      isIndex: false,
      studyList: [],
      pageList: [1, 2, 3],
      currentIndex: 0,
      pageIndex: 1,
      pageSize: 6,
      total: 0,
      maxPageIndex: 1,
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  created() {
    this.init();
    // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  beforeDestroy() {
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
  },
  methods: {
    handleMediaQueryChange(event) {
      if (event.matches) {
        this.isIndex = false;
      } else {
        this.isIndex = true;
      }
    },
    setMaxHeight() {
      this.$refs.studyCollectionInfo.style.maxHeight =
        window.innerHeight * 0.7 + "px"; // 设置最大高度为屏幕高度的70%
    },
    // 替换中文双引号为英文双引号
    replaceChineseQuotes(text) {
      if (!text) return text;
      // 处理HTML实体编码的中文双引号
      let result = text.replace(/&ldquo;/g, '"');
      result = result.replace(/&rdquo;/g, '"');
      // 处理直接的中文引号字符
      result = result.replace(/[“”‘’]/g, '"');
      return result;
    },

    init() {
      this.$api.get("/study/list", { current: 1, pageSize: 10 }, (r) => {
        const { data, code } = r;
        if (code == 0 && data.length > 0) {
          this.studyList = data.map(item => ({
            ...item,
            contentEn: this.replaceChineseQuotes(item.contentEn)
          }));
        }
      });
    },
    goLink(item) {
      if (item.linkUrl) {
        window.open(item.linkUrl, '_blank');
      }
    },
  },
};
</script>
<style scoped>
.studyCollection {
  position: relative;
  margin-top: 94px;
  padding-bottom: 100px;
  background-color: #b89977;
}
.study-floor-img {
  width: 100%;
  height: 1110px;
  object-fit: cover;
}
.studyCollection-inner {
  position: relative;
  width: 1440px;
  height: 100%;
  min-height: 1110px;
  margin: -1110px auto 0px;
}
.studyCollection-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  margin: 52px 0 32px;
}
.studyCollection-title-img {
  width: 280px;
  height: 62px;
  object-fit: cover;
}
.studyCollection-info {
  width: 1440px;
  min-height: 1100px;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 60px;
}
.study-collection-show {
  position: relative;
  margin: 310px 80px 40px;
  width: 310px;
  height: 339px;
  background-image: url(../../assets/CYTworkBg.png);
  background-repeat: no-repeat;
  background-size: contain;
  padding-top: 150px;
  cursor: pointer;
}

.study-collection-img {
  position: absolute;
  top: -240px;
  right: -20px;
  width: 290px;
  height: 400px;
  object-fit: cover;
}
.study-collection-work-info {
  padding: 0 20px 0 40px;
}
.study-collection-work-title {
  font-family: SourceHanSansCN-Medium;
  font-size: 22px;
  color: #876e4c;
  letter-spacing: 0;
  text-align: left;
  font-weight: 500;
  margin: 19px 0 10px;
}
.study-collection-work-dec {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #98989f;
  letter-spacing: 0;
  text-align: left;
  line-height: 22px;
  font-weight: 400;
}
@media (max-width: 1440px) {
  .studyCollection-inner {
    position: relative;
    width: 90%;
    height: 100%;
    min-height: 1110px;
    margin: -1110px auto 0px;
  }
  .studyCollection-info {
    width: 100%;
    min-height: 1100px;
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
  }
  .study-collection-img {
    position: absolute;
    top: -240px;
    right: -20px;
    width: 260px;
    height: 380px;
    object-fit: cover;
  }
  .study-collection-show {
    position: relative;
    margin: 310px 50px 40px;
    width: 310px;
    height: 483px;
    background-image: url(../../assets/CYTworkBg.png);
    background-repeat: no-repeat;
    background-size: contain;
    padding-top: 150px;
    cursor: pointer;
  }
}
@media (max-width: 960px) {
  .studyCollection {
    position: relative;
    margin-top: 80px;
    padding-bottom: 0px;
    background-color: #b89977;
  }
  .studyCollection-inner {
    position: relative;
    height: 100%;
    width: 100%;
    min-height: auto;
    margin: 100px auto 20px;
  }
  .studyCollection-info {
    min-height: 1100px;
    width: 100%;
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
  }
  .study-collection-show {
    position: relative;
    margin: 210px auto 0px;
    width: 395px;
    height: 483px;
    background-image: url(../../assets/CYTworkBg.png);
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 150px;
  }

  .study-collection-img {
    position: absolute;
    top: -188px;
    right: 0;
    width: 100%;
    height: 480px;
    object-fit: cover;
  }
  .study-collection-work-info {
    padding: 140px 20px 0 25px;
  }
  .study-collection-work-title {
    font-family: SourceHanSansCN-Medium;
    font-size: 22px;
    color: #876e4c;
    letter-spacing: 0;
    text-align: left;
    font-weight: 500;
    margin: 19px 0 10px;
  }
  .study-collection-work-dec {
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #98989f;
    letter-spacing: 0;
    text-align: left;
    line-height: 22px;
    font-weight: 400;
  }

}

@media (max-width: 430px) {
  .studyCollection-inner {
    position: relative;
    height: 100%;
    width: 100%;
    min-height: auto;
    margin: 20px auto 40px;
  }
  .study-collection-show {
    position: relative;
    margin: 290px auto -100px;
    width: 88%;
    height: 500px;
    background-image: url(../../assets/CYTworkBg.png);
    background-repeat: no-repeat;
    background-size: contain;
    padding: 210px 0px 40px;
  }
  .study-collection-img {
    position: absolute;
    top: -260px;
    right: 0px;
    width: 100%;
    height: 480px;
    object-fit: cover;
  }
  .study-collection-work-info {
    width: 100%;
    padding: 18px 20px 0px;
  }
  .study-collection-work-title {
    font-family: SourceHanSansCN-Medium;
    font-size: 18px;
    color: #876e4c;
    letter-spacing: 0;
    text-align: left;
    font-weight: 500;
    margin: 10px 0 5px;
  }
  .study-collection-work-dec {
    font-family: SourceHanSansCN-Regular;
    font-size: 12px;
    color: #98989f;
    letter-spacing: 0;
    text-align: left;
    line-height: 18px;
    font-weight: 400;
  }
}
@media (max-width: 380px) {
    .study-collection-show {
      height: 465px;
    }
}
@media (max-width: 320px) {
    .study-collection-show {
      height: 415px;
      padding: 155px 0px 40px;
    }
    .study-collection-img{
      height: 430px;
    }
}
</style>
